import script from "./indexqq.vue?vue&type=script&setup=true&lang=js"
export * from "./indexqq.vue?vue&type=script&setup=true&lang=js"

import "./indexqq.vue?vue&type=style&index=0&id=46584e6a&scoped=true&lang=css"

import exportComponent from "E:\\李小东项目管理\\23-5\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46584e6a"]])

export default __exports__